/* tslint:disable */
import {Injectable, Injector} from '@angular/core';
import {RegionsService} from "./regions/regions.service";
import {ScreenshotState} from "./atlas-shared.service";

@Injectable({
    providedIn: 'root'
})
export class RecordVideosService {
    meceV2RegionsLeavesIDsList = [];

    recordedRegionsCount = 0; // Tracks the number of regions drawn on the standard brain and serves as the current index in the meceV2RegionsLeavesIDsList
    pendingRegionDraws = 8; // Each 8 rotations, draw a region

    constructor(private injector: Injector) {

        this.meceV2RegionsLeavesIDsList = [1048, 1056, 1091, 1108, 1125, 1132, 1085, 1099, 1062, 1124, 1066, 1058, 1072, 1145, 1147,
            1089, 1144, 1120, 1138, 1092, 1055, 1071, 1086, 1114, 1082, 1057, 1069, 1141,
            1052, 1064, 1133, 1074, 1136, 1070, 1090, 1105, 1109, 1111, 1095, 1118, 1073,
            1094, 1054, 1146, 1140, 1123, 1113, 1088, 1131, 1129, 1137, 1139, 1046, 1078,
            1051, 1154, 1067, 1116, 1045, 1060, 1106, 1103, 1100, 1044, 1047, 1077, 1079,
            1107, 1121];
    }

    handleHerwigRegionDraw(screenshotState: ScreenshotState) {
        this.pendingRegionDraws -= 1;

        let regionsService = this.injector.get<RegionsService>(RegionsService);
        let hasMoreRegions = this.recordedRegionsCount < this.meceV2RegionsLeavesIDsList.length;

        if (hasMoreRegions && this.pendingRegionDraws === 0) {
            const regionId = this.meceV2RegionsLeavesIDsList[this.recordedRegionsCount];
            const region = regionsService.regionsData.dictionary[regionId];

            region.selected = true;
            regionsService.onRegionSelectionChanged(regionId, false);

            this.recordedRegionsCount++;
            this.pendingRegionDraws = 8;
            screenshotState.isWaitingForScreenshot = false;
        } else {
            screenshotState.isWaitingForScreenshot = false;
        }
    }

}
